export const LOCAL_STORAGE_LAST_LOGON_USERNAME_KEY = 'last_logon_username';
export const LOCAL_STORAGE_NATIVE_AUTH_KEY = 'native_auth';
